import React from 'react';
import { IoMdPerson, IoIosPeople } from 'react-icons/io';
import { FaBuilding } from 'react-icons/fa';
import { ImKey } from 'react-icons/im';
import { GrEmptyCircle } from 'react-icons/gr';
import { IoSettingsOutline } from 'react-icons/io5';
import { Avatar } from '@nextui-org/react';

const ProfileComponent = ({ user, activeTab, onTabChange }) => {
  const menuItems = [
    { id: 'general', icon: IoMdPerson, label: 'Genel Bilgiler', active: true },
    { id: 'connections', icon: IoIosPeople, label: 'Bağlantılar', active: false },
    { id: 'organizations', icon: FaBuilding, label: 'Firmalarım', active: false },
    { id: 'security', icon: ImKey, label: 'Güvenlik', active: false },
    { id: 'badges', icon: GrEmptyCircle, label: 'Rozetlerim', active: false },
    { id: 'settings', icon: IoSettingsOutline, label: 'Genel Ayarlar', active: false },
  ];

  return (
    <div className="border border-gray-200 dark:border-dark-300 bg-white dark:bg-dark-300 rounded-lg overflow-hidden">
      {/* Profil Üst Bilgi */}
      <div className="p-6 border-b border-gray-200 dark:border-dark-300">
        <div className="flex flex-col items-center text-center">
          <Avatar
            src={(user?.uimg && /^https?:\/\//i.test(user.uimg))
              ? user.uimg
              : (user?.uimg
                ? `${process.env.REACT_APP_USERIMG || ''}${user.uimg}.${user.uimgtype || 'png'}`
                : (process.env.REACT_APP_USERIMG_BLANK || '/assets/heypena-proffil.png'))}
            className="h-24 w-24 mb-4"
            classNames={{
              base: "ring-4 ring-gray-200 dark:ring-dark-500",
            }}
          />
          <h1 className="text-xl font-semibold text-[#283252] dark:text-darkWhite-300">
            {user?.ufname !== undefined ? `${user.ufname || ''} ${user.ulname || ''}`.trim() : "Yükleniyor..."}
          </h1>
          <p className="text-sm text-gray-500 dark:text-darkWhite-100 mt-1">
            {user?.uwork || "Ünvan belirtilmemiş"}
          </p>
          {user?.ulocation && (
            <p className="text-xs text-gray-400 dark:text-darkWhite-200 mt-1">
              📍 {user.ulocation}
            </p>
          )}
        </div>
      </div>

      {/* Menü */}
      <div className="p-2">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onTabChange && onTabChange(item.id)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-md transition-all duration-200 mb-1 ${
                isActive
                  ? 'bg-blue-50 dark:bg-dark-500 text-blue-600 dark:text-darkViolet'
                  : 'text-gray-600 dark:text-darkWhite-300 hover:bg-gray-50 dark:hover:bg-dark-500'
              }`}
            >
              <Icon className={`text-lg ${isActive ? 'text-blue-600 dark:text-darkViolet' : ''}`} />
              <span className="text-sm font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ProfileComponent;